import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from 'react-bootstrap';
import BackIcon from '../../../../styles/images/back-without-bg.png';
import Barcode from 'react-barcode';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import Swal from 'sweetalert2';
import axios from "axios";
import { BASE_SITE, GENERATE_BUY_CODE_POST } from '../../../../apis'; 
import { handleChangeBarcodeGeneratePage, handleChangeTimerTimeBarcodeGeneratePage } from "../../../../redux/actions/pages/buy/barcode_generate";
import SitagLogo from '../../../../styles/images/sitag-logo.png';
import { handleChangeDataBottomSheet } from '../../../../redux/actions/partials/footer/bottom_sheet';

const BarcodeGenerate = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { token } = useSelector(state => state.user);
    const { barcode, timerTime } = useSelector(state => state.barcode_generate);

    useEffect(() => {
        callApiGenerateCode();
        // eslint-disable-next-line
    }, [BarcodeGenerate]);

    useEffect(() => {
        handleTimerTime();
        // eslint-disable-next-line
    }, [timerTime]);

    let setTimeOut;
    const handleTimerTime = () => {
        if (timerTime > 0)
            setTimeOut = setTimeout(() => {
                if (timerTime > 0) {
                    dispatch(handleChangeTimerTimeBarcodeGeneratePage(timerTime - 1));
                } else
                    clearTimeout(setTimeOut);
            }, 1000);
        else {
            if (timerTime !== 0)
                dispatch(handleChangeTimerTimeBarcodeGeneratePage(0));
        }
    };

    const handleBackBtn = () => {
        navigate(-1);
    };

    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'primary-border primary-txt-color font-weight-300 radius-12 w-100 py-2 px-5',
        },
        buttonsStyling: false
    });

    const callApiGenerateCode = () => {
        dispatch(handleSetBackdropLoading(true));

        axios({
            method: 'get',
            url: BASE_SITE + GENERATE_BUY_CODE_POST,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            switch (response.data.status) {

                case 'error':
                    btnOkSingle.fire({
                        title: "خطا ",
                        text: response.data.message,
                        imageUrl: SitagLogo,
                        imageHeight: 80,
                        imageAlt: 'سیتگ',
                        confirmButtonText: "تایید",
                    });
                    break;
                case 'ok':
                    dispatch(handleChangeBarcodeGeneratePage(response.data.barcode));
                    dispatch(handleChangeTimerTimeBarcodeGeneratePage(response.data.timer_time));
                    break;
                default:
                    btnOkSingle.fire({
                        title: "خطا در ارسال کد",
                        text: "لطفا مجددا تلاش کنید.",
                        imageUrl: SitagLogo,
                        imageHeight: 80,
                        imageAlt: 'سیتگ',
                        confirmButtonText: "تایید",
                    });
            }
            dispatch(handleSetBackdropLoading(false));
        }, () => {
            dispatch(handleSetBackdropLoading(false));
            btnOkSingle.fire({
                title: "خطا",
                text: "لطفا مجددا تلاش کنید.",
                imageUrl: SitagLogo,
                imageHeight: 80,
                imageAlt: 'سیتگ',
                confirmButtonText: "تایید",
            });
        });
    };

    const closeBottomSheet = () => {
        dispatch(handleChangeDataBottomSheet('isOpen', false));
    };

    return (

        <div id="barcode-generate-page" onClick={closeBottomSheet} >

            <Row className="py-3 white-bg sticky top-0 z-index-2">
                <Col xs={1}><img src={BackIcon} alt="back" onClick={handleBackBtn} /></Col>
                <Col xs={10}><h5 className="text-center">بارکد پرداخت</h5></Col>
                <Col xs={1}></Col>
            </Row>

            <Row style={{height: `${window.innerHeight}px`}} className="gray-bg">
                <Col xs={12}>
                    <div className="white-bg-round text-center py-4">
                        <Barcode value={barcode} displayValue={false} />
                        <p>کد خرید: {barcode}</p>
                    </div>

                    <div className="text-center mt-3 dark-blue-txt-color">
                        {
                            timerTime > 0 ?
                                timerTime
                            :
                            <span onClick={callApiGenerateCode} role="button">ایجاد بارکد جدید</span>
                        }
                    </div>

                    <h6 className="mt-5">بارکد را جهت اسکن به صندوقدار فروشگاه نشان دهید</h6>
                    <h6 >یا کد خرید را برای صندوقدار بخوانید</h6>
                </Col>
            </Row>

                    
            

                    
             
            
        </div>

    );
}

export default BarcodeGenerate;